// extracted by mini-css-extract-plugin
module.exports = {"ooka-together-image":"ookaTogetherImage_ooka-together-image__YoLkM"};